var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      staticClass: "workspace-module-container",
      attrs: { id: "projects-lite" },
      on: { "ps-y-reach-end": _vm.scrollReachEnd }
    },
    [
      _c("div", { attrs: { id: "projects-lite-label" } }, [
        _vm._v("Выберите дом и начните подбор дизайна прямо сейчас\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "projects-grid-nine",
          attrs: { id: "projects-lite-items-container" }
        },
        _vm._l(_vm.projectList, function(project) {
          return _c(
            "div",
            {
              staticClass: "project-card-lite",
              class: { "active-project": _vm.projectSelected === project.guid },
              attrs: { title: project.data_json.name },
              on: {
                click: function($event) {
                  return _vm.openProject(project)
                }
              }
            },
            [
              _c("TitlePhotoForProject", {
                attrs: { dataProject: project.data_json }
              })
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.waitingResponseToProjectsRequest
        ? _c(
            "div",
            { staticClass: "ap-loader-grid" },
            [
              _c("SpinnerTwo"),
              _vm._v(" "),
              _c("div", { staticClass: "ap-loader-text" }, [
                _vm._v("\n            Идет загрузка проектов ...\n        ")
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }